<input
    type="email"
    [formControl]="control"
    [id]="id"
    class="sh-input-field sh-form-group__input"
    [attr.autocomplete]="autocomplete || null"
    [attr.placeholder]="message$ | async"
    [attr.aria-describedBy]="invalid ? describeLabelId : null"
    [attr.aria-invalid]="invalid"
    [attr.disabled]="disabled ? true : null"
/>
